// extracted by mini-css-extract-plugin
export default {"CountdownRenderer":"CountdownRenderer_CountdownRenderer__HkJ-D","Days":"CountdownRenderer_Days__KB-4+","Highlight":"CountdownRenderer_Highlight__h2O-U"};